<template>
    <div v-if="data" class="container">
      <iframe :src="data.data.path" width="100%" height="100%" class="frame"></iframe>
    </div>
</template>

<script>
import layoutMixin from "@/mixins/layoutMixin";
import { BFormInput, BFormGroup, BButton } from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  mixins: [layoutMixin],
  components: {
    BFormInput,
    BButton,
    BFormGroup,
  },
  props: {
    data: {
      type: Object,
      required: true,
    },
  },
  directives: {
    Ripple,
  },
  mounted() {
  },
};
</script>

<style lang="scss" scoped>
  .container{
    height: 100%;
    width: 100%;
    position: relative;
  }
.frame {
  width: 100%;
  height: 100%;
  border: none;
  position: absolute;
  top: 0;
  left: 0;
  overflow: hidden;
}
</style>
